import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=40027e91&scoped=true"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=js"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=40027e91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40027e91",
  null
  
)

export default component.exports